import React from 'react';
import { CheckCircle2, MapPin } from 'lucide-react';
import { COUNTRIES_BY_PATH } from './constants';

/**
 * Step 2 — Country selection (multi-select, filtered by chosen path).
 */
export function CountriesStep({ config, form, toggleCountry }) {
  return (
    <div className="space-y-4" data-testid="step-countries">
      <div>
        <div className="flex items-center gap-2 text-[var(--gp-gold)]">
          <MapPin className="w-4 h-4" />
          <span className="text-[10px] tracking-[0.3em] uppercase font-medium">Step 2 / 4</span>
        </div>
        <h3 className="font-serif text-2xl text-[hsl(var(--primary))] mt-1">Quale paese ti interessa?</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Puoi selezionarne più di uno.
          {form.path === 'real_estate' && (
            <span className="block mt-1 text-[12px] text-[var(--gp-gold)]">
              ⓘ Per Real Estate sono disponibili solo Albania e Indonesia.
            </span>
          )}
          {form.path === 'both' && (
            <span className="block mt-1 text-[12px] text-[var(--gp-gold)]">
              ⓘ Real Estate richiede Albania o Indonesia; Thailandia (solo equity) è esclusa.
            </span>
          )}
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {config.countries
          .filter((c) => !form.path || (COUNTRIES_BY_PATH[form.path] || []).includes(c.id))
          .map((c) => {
            const sel = form.countries.includes(c.id);
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => toggleCountry(c.id)}
                className={`p-4 rounded-xl border-2 text-left transition-all ${
                  sel
                    ? 'border-[var(--gp-gold)] bg-[var(--gp-gold)]/10 shadow-md'
                    : 'border-border bg-[var(--surface-2)] hover:border-[var(--gp-gold)]/50'
                }`}
                data-testid={`qf-country-${c.id}`}
              >
                <div className="text-3xl">{c.flag}</div>
                <div className="font-serif text-lg mt-1.5 text-[hsl(var(--primary))]">{c.label}</div>
                <div className="text-xs text-muted-foreground">Resort {c.resort}</div>
                {sel && (
                  <CheckCircle2 className="w-4 h-4 text-[var(--gp-gold)] mt-2" />
                )}
              </button>
            );
          })}
      </div>
    </div>
  );
}
